import styled from "styled-components";
import { COLOURS } from "../theme";
import ShinyText from "./ShinyText";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Wrap = styled.footer`
  margin-top: 64px;
  padding: 32px 12px;
  border-top: 1px solid ${COLOURS.textMuted};
  text-align: center;
  color: ${COLOURS.textMuted};

  @media (max-width: 600px) {
    padding: 24px 8px;
  }
`;

const Links = styled.nav`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  gap: 20px;
`;

const IconLink = styled.a`
  color: ${COLOURS.textMuted};
  font-size: 22px;
  transition: color 0.2s linear;

  &:hover,
  &:focus-visible {
    color: ${COLOURS.accent};
    outline: none;
  }
`;

const Copy = styled.small`
  display: block;
  margin-top: 20px;
  color: ${COLOURS.textMuted};
  font-size: 14px;
`;

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Wrap>
      <ShinyText
        text="Made with 🤍 by Amy J"
        disabled={false}
        speed={3}
      />

      <Links aria-label="Social links">
        <IconLink
          href="https://github.com/amylouisejordan"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          <FontAwesomeIcon icon={faGithub} aria-hidden="true" />
        </IconLink>

        <IconLink
          href="https://linkedin.com/in/amy-jordan333"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedin} aria-hidden="true" />
        </IconLink>
      </Links>

      <Copy aria-label="Copyright notice">
        © {year} Amy Jordan. All rights reserved.
      </Copy>
    </Wrap>
  );
};

export default Footer;
